module.exports = __webpack_public_path__ + "img/shot_img20022502.e302ca6f.gif";